<template>
  <div>
    <dashboard-header :text='$t("department.caption")'/>
    <v-card
        elevation="0"
        class="card-border-10">
      <d-table
          class="pt-10 px-10"
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :item-click="onItemTableClick"
          :edit="isEdit ? editItem : null"
          :on-delete="isDelete ? deleteItem : null"
          :add="isCreate ? addItem : null"
          :change-password="isChangePassword ? changePassword : null"
          :get-items="getItems"
          :custom-total-rows="totalRows"
          :on-delete-content="onDeleteContent"
          :placeholder="$t('department.placeholderSearch')"
          context="department"
      />

    </v-card>

  </div>
</template>

<script>
import dTable from "../base/DataTable.vue";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import mixin from "../../mixin";
import { PERMISSIONS } from "../../config/permissions";

export default {
  name: "ListDepartment",
  components: {DashboardHeader, dTable},
  props: {
    openTab: {
      type: Function,
      required: true
    }
  },
  mixins: [mixin],
  data() {
    return {
      // table
      items: [],
      totalRows: 0,
      optionParams: null,
      // removed static permissions - moved to computed
    };
  },
  computed: {
    // Permission computed properties
    isCreate() {
      return this.hasPermission(PERMISSIONS.DEPARTMENT_CREATE);
    },
    isEdit() {
      return this.hasPermission(PERMISSIONS.DEPARTMENT_UPDATE);
    },
    isDelete() {
      return this.hasPermission(PERMISSIONS.DEPARTMENT_DELETE);
    },
    isChangePassword() {
      return this.hasPermission(PERMISSIONS.DEPARTMENT_CHANGE_PASSWORD);
    },
    fields() {
      return [
        {key: "name", label: this.$t("ui.nameDepartment")},
        {key: "dpInchargeEmployeeName", label: this.$t("ui.accountName"), sortable: false},
        {key: "dpEmail", label: this.$t("ui.email"), sortable: false},
        {key: "dpPhoneNumber", label: this.$t("ui.phoneNumber"), sortable: false},
        {key: this.isEdit || this.isDelete ? "actions" : null, label: "", sortable: false},
      ]
    }
  },
  mounted() {
    this.onTab()
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams)
    },
    async getItems(optionParams) {
      if (!optionParams) return
      this.optionParams = optionParams
      let res = await this.get(API2.DEPARTMENT, optionParams)
      // console.log('res', res)
      if (!res) return
      this.totalRows = res.total
      this.items = res.data.map(value => {
        return {
          data: {...value, idDetail: value.departmentId},
          name: value.name ? value.name : "",
          dpInchargeEmployeeName: value.dpInchargeEmployeeName,
          dpEmail: this.shortenText(value.dpEmail, 20),
          dpPhoneNumber: value.dpPhoneNumber,
        };
      });
    },
    onDeleteContent() {
      return i18n.t("ui.confirmDataDelDepartment")
    },
    async deleteItem(item) {
      let res = await this.delete(API2.DEPARTMENT, {path: item.data.departmentId})
      if (res) {
        this.showToast("success", i18n.t("base.notification"), `${i18n.t("base.deleteSuccessful")}`)
        this.getItems(this.optionParams);
      }
    },
    addItem() {
      this.openTab(2)
    },
    editItem(item) {
      this.openTab(2, item)
    },
    onItemTableClick(item) {
      if (!this.checkPermissionOrShowError(PERMISSIONS.DEPARTMENT_VIEW, 'Bạn không có quyền xem chi tiết khoa')) {
        return;
      }
      this.openTab(1, item)
    },
    changePassword(item) {
      this.openTab(3, item)
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
  }
}
;
</script>

<style></style>
